import {
    CaretRightOutlined,
    RightOutlined,
    MinusCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { Row, Col, Form, Input, Divider, Select, Button, Space } from "antd";
import React, { useEffect, useState } from "react";

import accountService from "../../api/account.service";

import ProgrammeCommercialService from "../../api/programme.commercial.service";
import { SUCCESS_STATUS } from "../../utility/Constants";
import commonUtility from "../../utility/Utils";

const { Option } = Select;


function PaymentModeDetails(props) {


 //   const x = props.initialValuesOtherItemList;
    const [paymentModeList, setPaymentModeList] = useState([]);
 
    const [formDetailStateX, setFormDetailStateX] = useState([]);
    const [itemObject, setItemObject] = useState({});
    const [isOtherPaymentFieldsRequired, setIsOtherPaymentFieldsRequired] = useState(false);
    const [totalPayableReceiptAmount, setTotalPayableReceiptAmount] = useState(0);











    const onSelectPaymentMode = (x, object) => {
        //console.log(x, d);
        setItemObject({
            payment_mode_id: object.id,
            payment_mode: object.payment_mode,
            dr_account_id: object.account_id,
        })
    }

    const addPaymentMode = () => {
        //const payment_mode_id = props.paymentForm.getFieldValue("select_payment_modes");

   
        // setFormDetailState([...formDetailState,{"component_details_others" : [x]}]);
        if (itemObject.payment_mode_id > 0) {


            setFormDetailStateX([...formDetailStateX, {

                payment_mode_id: itemObject.payment_mode_id,
                mode_description: itemObject.payment_mode,
                dr_account_id: itemObject.dr_account_id,
                cheque_no: "",
                cheque_date: "",
                bank_name: "",
                bank_branch: "",
                amount: ""




            }]);




            

            props.paymentForm.setFieldsValue({
                select_payment_modes: ""
            });

            setItemObject({
                payment_mode_id:0,
                payment_mode:"",
                account_id:0,
            })
        }
    }

    const handleRemove = (event, index) => {
        console.log("index", formDetailStateX);
        props.calulateShortExcessAmount(index , "REMOVE");
        const list = [...formDetailStateX];
        list.splice(index, 1);
        setFormDetailStateX(list);

    };




    const handleFormChange = (event, index) => {
        let data = [...formDetailStateX];
        data[index].amount = event.target.value;
        setFormDetailStateX(data);
        // if (commonUtility.sanitizeValue(event.target.value) &&  event.target.value > 0) {
        //     props.calulateShortExcessAmount(index , "ADD");
        // }
        props.calulateShortExcessAmount(index , "ADD");

        const mode_description = props.paymentForm.getFieldValue(["payment_data",index,"mode_description"]);
        if(mode_description.toLowerCase() != "cheque") {
            readonlyInputs(index,true)
        }
        else{
            readonlyInputs(index,false)
        }
    }

    const handleChecqueNoChange = (event, index) => {
        let data = [...formDetailStateX];
        data[index].cheque_no = event.target.value;
        setFormDetailStateX(data);
    }

    const handleChecqueDateChange = (event, index) => {
        let data = [...formDetailStateX];
        data[index].cheque_date = event.target.value;
        setFormDetailStateX(data);
    }

    const handleBankNameChange = (event, index) => {
        let data = [...formDetailStateX];
        data[index].bank_name = event.target.value;
        setFormDetailStateX(data);
    }

    const handleBankBranchChange = (event, index) => {
        let data = [...formDetailStateX];
        data[index].bank_branch = event.target.value;
        setFormDetailStateX(data);
    }


    const readonlyInputs = (index,readonlyValue) => {
        document.getElementById('payment_data_'+index+'_cheque_no').value = "";
        document.getElementById('payment_data_'+index+'_cheque_date').value = "";
        document.getElementById('payment_data_'+index+'_bank_name').value = "";
        document.getElementById('payment_data_'+index+'_bank_branch').value = "";

        document.getElementById('payment_data_'+index+'_cheque_no').readOnly = readonlyValue;
        document.getElementById('payment_data_'+index+'_cheque_date').readOnly = readonlyValue;
        document.getElementById('payment_data_'+index+'_bank_name').readOnly = readonlyValue;
        document.getElementById('payment_data_'+index+'_bank_branch').readOnly = readonlyValue;
    }

    useEffect(() => {
        props.paymentForm.setFieldsValue({ "payment_data": formDetailStateX });
    }, [formDetailStateX]);



    useEffect(()=>{
        let paymentdtls = props.paymentDetailList
        


        const newData = paymentdtls.map(details => { 
            return {...details}
      });


      console.log("newDate Terjud",newData)
      setFormDetailStateX(newData)
      props.paymentForm.setFieldsValue({ "payment_data": formDetailStateX });
      
        
      //setFormDetailStateX([...formDetailStateX,newData ]);


       


      
    },[props.paymentDetailList]);

    useEffect(() => {
        accountService.paymentModeList().then((res) => {
            console.log(res.data.response_data);
            setPaymentModeList(res.data.response_data);
        });
    }, [])


    useEffect(() => {
        setTotalPayableReceiptAmount(props.totalPayableAmount);
    }, [props.totalPayableAmount])


    useEffect(()=>{
        console.log("props.totalPayableAmount",props.totalPayableAmount)
        props.paymentForm.setFieldsValue({
            payable_amount:props.totalPayableAmount
        })
    },[props.totalPayableAmount]);

    return (
        <div>





            <Form.List
                // name={FORM_NAME_COMPONENT_DETAILS_ADMISSION}
                name="payment_data"
            // initialValue={defaultFields}
            >
                {(fields, { add, remove }) => (
                    <>
                        {
                            fields.map(({ key, name, ...restField }, index) => (
                                <div key={key}>
                                    <Row
                                        key={key}
                                        style={{
                                            display: "flex",
                                            marginBottom: 8,
                                            borderBottom: "0px solid red",
                                        }}
                                        align="baseline"
                                        gutter={15}
                                    >
                                        <Col xs={24} xl={3}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "mode_description"]}
                                                rules={[
                                                    { required: true, message: "" },
                                                ]}
                                                label="Mode"
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>

                                            <Form.Item {...restField} name={[name, "payment_mode_id"]} hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                            <Form.Item {...restField} name={[name, "dr_account_id"]} hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>


                                        </Col>
                                        <Col xs={24} xl={4}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "amount"]}
                                                rules={[{ required: true, message: "" }]}
                                                label="Amount"
                                                onChange={(event) => handleFormChange(event, index)}

                                            >
                                                <Input placeholder=""  />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={3}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "cheque_no"]}
                                                rules={[{ required: isOtherPaymentFieldsRequired, message: "" }]}
                                                label="Cheque No"
                                                onChange={(event) => handleChecqueNoChange(event, index)}
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={4}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "cheque_date"]}
                                                rules={[{ required: isOtherPaymentFieldsRequired, message: "" }]}
                                                label="Cheque Date"
                                                onChange={(event) => handleChecqueDateChange(event, index)}
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={4}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "bank_name"]}
                                                rules={[{ required: isOtherPaymentFieldsRequired, message: "" }]}
                                                label="Bank"
                                                onChange={(event) => handleBankNameChange(event, index)}
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={4}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "bank_branch"]}
                                                rules={[{ required: isOtherPaymentFieldsRequired, message: "" }]}
                                                label="Branch"
                                                onChange={(event) => handleBankBranchChange(event, index)}
                                            >
                                                <Input placeholder="" readOnly={true} />
                                            </Form.Item>
                                        </Col>


                                        <Col xs={24} xl={2}>
                                            <Form.Item label=" ">
                                                <MinusCircleOutlined onClick={(event) => handleRemove(event, index)} />
                                            </Form.Item>
                                        </Col>
                                    </Row>


                                    <Divider />
                                </div>
                            ))}







                    </>
                )}
            </Form.List>

            <Row gutter={20}>
                            <Col xs={24} xl={6} >
                                <Form.Item

                                    name="select_payment_modes"
                                    label="Payment Mode"
                                >
                                    <Select
                                        className="text-left"
                                        defaultValue="Select"
                                        onSelect={(value, event) => onSelectPaymentMode(value, event)}
                                    >
                                        {paymentModeList.length > 0
                                            ? paymentModeList.map((payment_mode_list) => (
                                                <Option
                                                    key={payment_mode_list.id}
                                                    value={payment_mode_list.payment_mode}

                                                    id={payment_mode_list.id}
                                                    payment_mode={payment_mode_list.payment_mode}
                                                    account_id={payment_mode_list.account_id}
                                                    account_name={payment_mode_list.account_name}

                                                >
                                                    {payment_mode_list.payment_mode}
                                                </Option>
                                            ))
                                            : ""}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={6} >
                                <Form.Item
                                    label=" "
                                >



                                    <Button
                                        className="custom-button-green"
                                        onClick={() => {
                                            addPaymentMode()
                                        }}
                                        icon={<PlusOutlined />}
                                    >
                                        Add Payment Mode
                                    </Button>
                                </Form.Item>
                            </Col>


                            <Col xs={24} xl={6} >
                                <Form.Item name="payable_amount" label=" " hidden={true} >
                                    <Input type="text"  readOnly={true}   />
                                </Form.Item>
                                        
                            </Col>

                            <Col xs={24} xl={6} >
                                <Form.Item name="payment_amount" label=" " hidden={true}>
                                    <Input type="text" readOnly={true}  />
                                </Form.Item>

                            </Col>
                        </Row>

        </div>
    );
}

export default PaymentModeDetails;
